import React, {
  useState,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import usePublicOffer
  from "../hooks/usePublicOffer";

import PublicOfferHeader
  from "../components/PublicOfferHeader";

import PublicOfferTotals
  from "../components/PublicOfferTotals";

import PaymentCheckout
  from "../../payments/components/PaymentCheckout";


const PublicOfferPaymentPage = () => {

  const {
    token,
  } = useParams();


  const navigate =
    useNavigate();


  const {
    publicOffer,
    loading,
    error,
  } =
    usePublicOffer(
      token
    );


  const [
    paymentError,
    setPaymentError
  ] = useState(null);


  /*
  |--------------------------------------------------------------------------
  | PAYMENT SUCCESS
  |--------------------------------------------------------------------------
  */

  const handlePaymentSuccess =
    async (
      payment
    ) => {

      console.log(
        "Payment successful:",
        payment
      );


      /*
      |--------------------------------------------------------------------------
      | IMPORTANT
      |--------------------------------------------------------------------------
      |
      | PaymentCheckout calls this only after
      | backend payment verification succeeds.
      |
      | Correct success route:
      |
      | /offer/:token/success
      |
      */

      navigate(
        `/offer/${token}/success`,
        {
          replace: true,

          state: {
            payment,
          },

        }
      );

    };


  /*
  |--------------------------------------------------------------------------
  | PAYMENT FAILED
  |--------------------------------------------------------------------------
  */

  const handlePaymentFailed =
    (paymentFailure) => {

      console.error(
        "Payment failed:",
        paymentFailure
      );


      setPaymentError(

        paymentFailure
          ?.response
          ?.data
          ?.message ||

        paymentFailure?.message ||

        paymentFailure
          ?.error
          ?.description ||

        "Payment failed. Please try again."

      );

    };


  /*
  |--------------------------------------------------------------------------
  | PAYMENT CLOSED
  |--------------------------------------------------------------------------
  */

  const handlePaymentClose =
    () => {

      console.log(
        "Payment checkout closed."
      );

    };


  /*
  |--------------------------------------------------------------------------
  | LOADING
  |--------------------------------------------------------------------------
  */

  if (loading) {

    return (
      <main className="public-offer-payment-page">

        <div className="public-offer-loading">

          <div className="public-offer-spinner" />

          <p>
            Loading payment details...
          </p>

        </div>

      </main>
    );

  }


  /*
  |--------------------------------------------------------------------------
  | ERROR
  |--------------------------------------------------------------------------
  */

  if (
    error ||
    !publicOffer
  ) {

    return (
      <main className="public-offer-payment-page">

        <div className="public-offer-error">

          <h1>
            Payment Unavailable
          </h1>

          <p>
            {error ||
              "Unable to load the offer."}
          </p>

        </div>

      </main>
    );

  }


  /*
  |--------------------------------------------------------------------------
  | PUBLIC OFFER STATUS
  |--------------------------------------------------------------------------
  |
  | Payment is only allowed after the public
  | offer has been accepted.
  |
  */

  const publicOfferStatus =
    publicOffer?.publicOffer?.status;


  if (
    publicOfferStatus !== "ACCEPTED"
  ) {

    return (
      <main className="public-offer-payment-page">

        <div className="public-offer-error">

          <h1>
            Payment Unavailable
          </h1>

          <p>
            This offer must be accepted before
            payment can be completed.
          </p>

        </div>

      </main>
    );

  }


  /*
  |--------------------------------------------------------------------------
  | OFFER
  |--------------------------------------------------------------------------
  */

  const offer =
    publicOffer?.offer;


  /*
  |--------------------------------------------------------------------------
  | OFFER NOT AVAILABLE
  |--------------------------------------------------------------------------
  */

  if (!offer) {

    return (
      <main className="public-offer-payment-page">

        <div className="public-offer-error">

          <h1>
            Payment Unavailable
          </h1>

          <p>
            Offer details are unavailable.
          </p>

        </div>

      </main>
    );

  }


  /*
  |--------------------------------------------------------------------------
  | RENDER
  |--------------------------------------------------------------------------
  */

  return (

    <main className="public-offer-payment-page">

      <div className="public-offer-container">

        <PublicOfferHeader
          publicOffer={
            publicOffer
          }
        />


        <div className="public-offer-payment-content">

          <div>

            <h2>
              Complete Payment
            </h2>

            <p>
              Your offer has been accepted.
              Please complete the payment
              below.
            </p>

          </div>


          <PublicOfferTotals
            publicOffer={
              publicOffer
            }
          />


          {paymentError && (

            <div
              className="public-offer-alert error"
            >
              {paymentError}
            </div>

          )}


          <PaymentCheckout

            /*
            |--------------------------------------------------------------------------
            | OFFER
            |--------------------------------------------------------------------------
            |
            | PaymentCheckout uses these values
            | for display and Razorpay prefill.
            |
            */

            offer={{

              ...offer,

              status:
                "ACCEPTED",

              offer_number:
                offer?.offerNumber ||
                offer?.offer_number,

              total_amount:
                offer?.totalAmount ||
                offer?.total_amount,

              valid_until:
                offer?.validUntil ||
                offer?.valid_until,

              currency:
                offer?.currency,

              client_name:
                publicOffer?.client?.name,

              client_email:
                publicOffer?.client?.email,

              client_phone:
                publicOffer?.client?.phone,

            }}


            /*
            |--------------------------------------------------------------------------
            | PUBLIC OFFER TOKEN
            |--------------------------------------------------------------------------
            |
            | This is required for the public payment
            | flow.
            |
            | PaymentCheckout should use this token
            | when creating the payment order.
            |
            */

            publicToken={
              token
            }


            /*
            |--------------------------------------------------------------------------
            | CALLBACKS
            |--------------------------------------------------------------------------
            */

            onPaymentSuccess={
              handlePaymentSuccess
            }

            onPaymentFailed={
              handlePaymentFailed
            }

            onClose={
              handlePaymentClose
            }

          />

        </div>

      </div>

    </main>

  );

};


export default PublicOfferPaymentPage;
